<template>
  <div>

    <div class="form-group">
      <label class="custom-label">Communication on POS</label>
      <br>
      <custom-checkbox v-for="posCom in posCommunicationCommunications"
        :key="`pos-${posCom.id}`"
        :label="posCom.name"
        :value="posCom.id"
        :checked="communicationPOS.includes(posCom.id)"
        @input="$store.commit('changeCommunicationPOS', $event)"
      >
        <documents-icon v-if="! nav"
          :communication="posCom"
          checkedType="posCommunicationIsChecked"
          documentsType="posCommunicationHasDocuments"
          @openModal="openDocumentUploadModal(posCom, 'pos_communications')"
        />
      </custom-checkbox>
    </div>

    <div class="form-group">
      <label class="custom-label">Communication on Social Media</label>
      <br>
      <custom-checkbox v-for="smCom in socialMediaCommunications"
        :key="`sm-${smCom.id}`"
        :label="smCom.name"
        :value="smCom.id"
        :checked="communicationSM.includes(smCom.id)"
        @input="$store.commit('changeCommunicationSM', $event)"
      >
        <documents-icon v-if="! nav"
          :communication="smCom"
          checkedType="smCommunicationIsChecked"
          documentsType="smCommunicationHasDocuments"
          @openModal="openDocumentUploadModal(smCom, 'social_media_communications')"
        />
      </custom-checkbox>
    </div>

    <div class="form-group">
      <label class="custom-label">Communication from Key Account</label>
      <br>
      <custom-checkbox v-for="kaCom in keyAccountCommunications"
        :key="`ka-${kaCom.id}`"
        :label="kaCom.name"
        :value="kaCom.id"
        :checked="communicationKA.includes(kaCom.id)"
        @input="$store.commit('changeCommunicationKA', $event)"
      >
        <documents-icon v-if="! nav"
          :communication="kaCom"
          checkedType="kaCommunicationIsChecked"
          documentsType="kaCommunicationHasDocuments"
          @openModal="openDocumentUploadModal(kaCom, 'key_account_communications')"
        />
      </custom-checkbox>
    </div>

    <custom-input
      label="Targetgroup"
      :value="targetgroup"
      @input="$store.commit('changeTargetgroup', $event)"
    />

    <div style="margin-top: 1em;" v-if="nav">
      <button type="button" class="btn btn-primary float-left"
        @click="$router.push(`/${stepType === 'trial' ? 'trials' : 'roll_outs'}/create/4`)"
        v-text="'Back'"
      />
      <button type="button" class="btn btn-primary float-right"
        @click="$router.push(`/${stepType === 'trial' ? 'trials' : 'roll_outs'}/create/6`)"
        v-text="'Next'"
      />
    </div>
    <template v-else>
      <button class="btn btn-primary float-right"
        v-if="isAdmin || isFromAuthUser"
        @click.prevent="$emit('update')"
        style="margin-bottom: 1em;"
      >
        <i class="fa fa-edit"></i> Save
      </button>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import StepMixin from './step-mixin'

  export default {
    mixins: [ StepMixin ],
    props: {
      canUploadImages: {
        default: false,
      },
    },
    data() {
      return {
        posCommunicationCommunications: [],
        socialMediaCommunications: [],
        keyAccountCommunications: [],
      }
    },
    methods: {
      openDocumentUploadModal(communication, type) {
        this.$emit('openDocumentUploadModal', {communication, type})
      },
    },
    computed: {
      ...mapState(['communicationPOS', 'communicationKA', 'communicationSM', 'targetgroup']),
    },
    mounted() {
      axios.get('/social_media_communications').then(({data}) => {
        this.socialMediaCommunications = data;
      })
      axios.get('/pos_communications').then(({data}) => {
        this.posCommunicationCommunications = data;
      })
      axios.get('/key_account_communications').then(({data}) => {
        this.keyAccountCommunications = data;
      })
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/CreateStep5.vue